import React from 'react'
import { Link } from 'react-router-dom'
import {
  Container,
  SectionOne,
  LogoOxeDin,
  LogoOxeTechLab,
  LogoOxeTechWork,
  LogoOxeTechHat,
  TriangleFrame,
  Text
} from './styles'
import MainHeader from '../../components/MainHeader'
import triangleFrame from '../../assets/homeTriangle/triangleFrameG.png'
import oxeTechHat from '../../assets/homeTriangle/oxeTechHat.png'
import oxeDinLogo from '../../assets/homeTriangle/oxeDinLogo.png'
import oxeTechLabLogo from '../../assets/homeTriangle/oxeTechLabLogo.png'
import oxeTechWorkLogoON from '../../assets/homeTriangle/oxeTechWorkLogoON.png'
import Typography from '@mui/material/Typography'

function Main(Props) {
  return (
    <>
      <MainHeader />
      <Container>
        
      </Container>
    </>
  )
}

export default Main
